import { DISABLE_EDIT_MSG_ID } from '@whelk/const';
import { isNative } from '@whelk/const/src/env';
import {
  ChatListSystemItem,
  ChatListUserItem,
  FAIL_STATUS,
  FEADBACKTYPE,
  REQUEST_STATE_TO_CARD_TYPE_MAP,
  SYSTEM_CARD_TYPE,
  SystemCardUITypeEnum,
} from '@whelk/const/src/textSseConst';
import { postCheckCache, postUploadSpider } from '@whelk/services/src/chat';
import {
  CHAT_MODEL_STYLE,
  CHAT_MSG_TYPE,
  ChatListItem,
  ChatMsgTypeEnum,
  FeedbackInfo,
  FeedbackPopupType,
  FeedbackStatusInfo,
  MSG_TYPE,
  MultiModalFormItem,
  REQUEST_FAIL_STATUS,
  REQUEST_STATUS,
  RequestFailEnum,
} from '@whelk/services/src/type/chat';
import { RootState, store } from '@whelk/store';

import { trackCustomEvent } from './track';

export const getChatId = (storeData: RootState) => {
  const chat = storeData?.chat || {};
  return chat.chatId;
};

export const getUserMsgID = (storeData: RootState) => {
  const chat = storeData?.chat || {};

  const chatList = [...(chat.chatList || [])];
  for (let i = chatList.length - 1; i >= 0; i--) {
    if (chatList[i].msgType === MSG_TYPE.USER) return chatList[i].msgId;
  }
  return '0';
};

export const getSystemMsgID = (storeData: RootState) => {
  const chat = storeData?.chat || {};
  const chatList = [...(chat.chatList || [])];
  for (let i = chatList.length - 1; i >= 0; i--) {
    if (chatList[i].msgType === MSG_TYPE.SYSTEM) return chatList[i].msgId;
  }
  return '0';
};

export const getChatLastUserItem = (storeData: RootState) => {
  const chatSystemLists =
    storeData?.chat?.chatList?.filter((item) => item.msgType === MSG_TYPE.USER) || [];
  const lastItem = chatSystemLists[chatSystemLists.length - 1] as ChatListUserItem;
  return lastItem;
};

export const getChatLastSystemItem = (storeData: RootState) => {
  const chatSystemLists =
    storeData?.chat?.chatList?.filter((item) => item.msgType === MSG_TYPE.SYSTEM) || [];
  const lastItem = chatSystemLists[chatSystemLists.length - 1] as ChatListSystemItem;
  return lastItem;
};

export const getLastChatItem = (storeData: RootState) => {
  const chatSystemLists =
    storeData?.chat?.chatList?.filter((item) => item.msgType === MSG_TYPE.USER) || [];
  const lastItem = chatSystemLists[chatSystemLists.length - 1] as ChatListUserItem;
  return lastItem;
};

// 获取最新的finishStatus
export const getLastSystemListFinishState = (storeData: RootState) => {
  const chatSystemLists =
    storeData?.chat?.chatList?.filter((item) => item?.msgType === MSG_TYPE.SYSTEM) || [];
  const lastSystemItem = chatSystemLists[chatSystemLists.length - 1] as ChatListSystemItem;
  return lastSystemItem?.finishStatus ?? null;
};

export const getLastSystemList = (storeData: RootState) => {
  const chatSystemLists =
    storeData?.chat?.chatList?.filter((item) => item?.msgType === MSG_TYPE.SYSTEM) || [];
  const lastSystemItem = chatSystemLists[chatSystemLists.length - 1] as ChatListSystemItem;
  return lastSystemItem?.systemList ?? [];
};

// 获取最后一个历史对话 当前展示的item 对话Info
export const getLastSystemTargetItemInfo = (
  chatList: Array<ChatListUserItem | ChatListSystemItem>,
) => {
  const chatSystemLists = chatList?.filter((item) => item?.msgType === MSG_TYPE.SYSTEM) || [];
  const lastSystemItem = (chatSystemLists[chatSystemLists.length - 1] as ChatListSystemItem) || {};
  const targetSystemListIndex = lastSystemItem?.targetSystemListIndex;
  const systemList = [...(lastSystemItem.systemList || [])];

  return systemList?.[targetSystemListIndex] || {};
};

// 获取最后一个历史对话 当前展示的 cardType
export const getLastSystemTargetCardType = (storeData: RootState) => {
  const chatSystemLists =
    storeData?.chat?.chatList?.filter((item) => item?.msgType === MSG_TYPE.SYSTEM) || [];
  const lastSystemItem = (chatSystemLists[chatSystemLists.length - 1] as ChatListSystemItem) || {};
  const targetSystemListIndex = lastSystemItem?.targetSystemListIndex;
  const targetSystemListItem = [...lastSystemItem.systemList]?.[targetSystemListIndex] || [];

  return targetSystemListItem?.cardType;
};

// 文字发送 push chatList initData
export const handleChatPushTextTypeData = (
  inputValue: string,
  newChatList: any[],
  msgSubtype: ChatMsgTypeEnum,
  multiModalList?: MultiModalFormItem[],
): Array<ChatListUserItem | ChatListSystemItem> => [
  {
    msgType: MSG_TYPE.USER,
    msgContent: inputValue,
    msgId: `${newChatList.length + 1}${isNative ? '' : DISABLE_EDIT_MSG_ID}`,
    msgSubtype,
    multiModalForm: multiModalList ?? [],
  },
  {
    msgType: MSG_TYPE.SYSTEM,
    msgId: `${newChatList.length + 2}`,
    targetSystemListIndex: 0,
    finishStatus: null,
    systemList: [
      {
        requestContent: '',
        cardType: SYSTEM_CARD_TYPE.LOADING,
        systemMsgID: `${newChatList.length + 2}`,
        chatSearchInfo: {
          netSearchList: [],
          status: '',
          statusCode: 0,
        },
        msgSubtype,
        generateImage: [],
        feadbackType: FEADBACKTYPE.CANCEL_DISLIKE,
      },
    ],
  },
];

// 处理 获取到的历史对话 数据
export const handleActiveHistoryItemData = (
  messageList: ChatListItem[],
): {
  newMessageList: Array<ChatListUserItem | ChatListSystemItem>;
  isRePull: boolean;
  needRequestSystemId: string;
} => {
  let needRequestSystemId = '';
  let isRePull = false;
  let newMessageList = [] as any[];

  try {
    newMessageList =
      messageList?.map((item, index) => {
        const chatSearchInfo = {
          netSearchList: item?.extra?.netSearchStatus?.linkDetail ?? [],
          statusCode: item?.extra?.netSearchStatus?.finalStatus?.statusCode ?? 0,
          status: item?.extra?.netSearchStatus?.finalStatus?.status,
          thumbnail: item.extra.netSearchStatus?.thumbnail,
        };
        if (item.msgType === MSG_TYPE.USER) {
          return {
            msgType: MSG_TYPE.USER,
            msgContent: item.content,
            msgSubtype: item?.msgSubtype,
            msgId: item.msgID,
            multiModalForm: item?.extra?.form ?? [],
            urlStatus: item?.extra?.urlStatus,
            warningText: item?.extra?.warningText,
          };
        }
        if (item?.msgType === MSG_TYPE.SYSTEM) {
          const content = item?.content?.trim();
          const newItem = {
            msgId: item.msgID,
            msgType: MSG_TYPE.SYSTEM,
            parentMsgID: item?.parentMsgID,
            finishStatus: null,
            targetSystemListIndex: 0,
            systemList: [] as any,
          };
          if (REQUEST_FAIL_STATUS.includes(item?.requestStatus as any)) {
            newItem.systemList = [
              {
                chatSearchInfo,
                thinkTime: item?.extra?.thinkTime,
                msgSubtype: item?.msgSubtype,
                requestContent: content,
                cardType: REQUEST_STATE_TO_CARD_TYPE_MAP[
                  item.requestStatus as RequestFailEnum
                ] as SystemCardUITypeEnum,
                systemMsgID: item.msgID,
                failingText: item?.failedText,
                stylizedReplyList: item?.extra?.stylizedReplyList,
                generateImage: item?.extra?.generateImage,
                feadbackType: item?.feadbackType || 0,
                ciCallResults: item?.extra?.ciCallResults,
                warningText: item?.extra?.warningText,
              },
            ];
          }
          // 成功
          if (item.requestStatus === REQUEST_STATUS.SUCCESS) {
            newItem.systemList = [
              {
                chatSearchInfo,
                thinkTime: item?.extra?.thinkTime,
                msgSubtype: item?.msgSubtype,
                requestContent: content,
                systemMsgID: item.msgID,
                followUpQuestions: item?.extra?.followUpQuestions,
                cardType: SYSTEM_CARD_TYPE.SUCCESS,
                generateImage: item?.extra?.generateImage,
                feadbackType: item?.feadbackType || 0,
                stylizedReplyList: item?.extra?.stylizedReplyList,
                scene: item?.extra?.scene,
                isUserStopped: item?.extra?.isUserStopped,
                ciCallResults: item?.extra?.ciCallResults,
                warningText: item?.extra?.warningText,
              },
            ];
          }
          // 最后一个需要请求
          if (
            // @ts-ignore
            [REQUEST_STATUS.PENDING, REQUEST_STATUS.CONTINUE_LOADING].includes(
              item.requestStatus as any,
            ) &&
            index === messageList.length - 1
          ) {
            isRePull = true;
            needRequestSystemId = item.msgID;
            let cardType = content ? SYSTEM_CARD_TYPE?.JUMPING_WAITING : SYSTEM_CARD_TYPE?.LOADING;

            if (
              item.requestStatus === REQUEST_STATUS.PENDING &&
              [CHAT_MODEL_STYLE.LOADING, CHAT_MODEL_STYLE.SEARCH_PROGRESS].includes(
                chatSearchInfo?.statusCode as any,
              )
            ) {
              cardType = SYSTEM_CARD_TYPE.SEARCHING;
            }
            newItem.systemList = [
              {
                msgSubtype: item?.msgSubtype,
                chatSearchInfo,
                requestContent: content,
                systemMsgID: item.msgID,
                cardType,
                generateImage: item?.extra?.generateImage,
                feadbackType: item?.feadbackType || 0,
                stylizedReplyList: item?.extra?.stylizedReplyList,
              },
            ];
          }
          return newItem;
        }
      }) || [];
  } catch (err) {
    console.log(err);
  }

  return {
    isRePull,
    needRequestSystemId,
    newMessageList: newMessageList as Array<ChatListUserItem | ChatListSystemItem>,
  };
};

// 随机取sug数组中的两个值
export const getRandomTwoSug = (suggestList: { sugText: string }[]) => {
  // 确保数组长度至少为2
  if (suggestList.length < 2) {
    return suggestList;
  }
  const firstIndex = Math.floor(Math.random() * suggestList.length);
  let secondIndex;
  do {
    secondIndex = Math.floor(Math.random() * suggestList.length);
  } while (firstIndex === secondIndex);

  return [suggestList[firstIndex], suggestList[secondIndex]];
};

export const getFeedbackPopUp = (feedbackStatus: FeedbackStatusInfo) => {
  let feedbackPopUpType: number | undefined;
  let feedbackPopUp: FeedbackInfo | undefined;

  for (const [key, value] of Object.entries(feedbackStatus)) {
    if (value && !value.finishOrSkip) {
      feedbackPopUpType = FeedbackPopupType?.[key as keyof typeof FeedbackPopupType];
      feedbackPopUp = value;
      break;
    }
  }

  if (feedbackPopUp && feedbackPopUpType) {
    feedbackPopUp.feedbackType = feedbackPopUpType;
  }
  return feedbackPopUp;
};

export const getMultiFileType = (formList: MultiModalFormItem[]) => {
  let fileType = '';
  if (formList && formList.length > 0) {
    formList.forEach((item) => {
      if (item.fileType && item.fileType !== '') {
        fileType = item.fileType as string;
      }
    });
  }
  return fileType;
};

// 展示重试按钮还是快捷重写指令按钮
export const showRetryOrReWriteButton = (
  chatList: Array<ChatListUserItem | ChatListSystemItem>,
): 'retry' | 'rewrite' => {
  const msgSubtype = getLastSystemTargetItemInfo(chatList)?.msgSubtype as ChatMsgTypeEnum;
  const cardType = getLastSystemTargetItemInfo(chatList)?.cardType;
  let type = 'retry' as 'retry' | 'rewrite';
  const reTryTypeList: ChatMsgTypeEnum[] = [CHAT_MSG_TYPE.TEXT_TO_IMG, CHAT_MSG_TYPE.CI];

  // 海螺机器人 & !文生图 & 非失败态
  if (!reTryTypeList.includes(msgSubtype) && !FAIL_STATUS?.includes(cardType)) {
    type = 'rewrite';
  }
  return type;
};
// 用来匹配指定文本中的超链接，匹配规则要前后端统一，因此regexp由后端下发
const matchHref = async (text: string) => {
  const regexp = store.getState().spider.regexp;
  const reg = new RegExp(regexp, 'g');
  return text.match(reg);
};

// 从服务端拉取合法的爬取文件信息，用于爬虫预检，《超过最大size》或《不在可支持的type列表内》的文件直接return
const getValidSpiderInfo = async () => {
  const preloadUrlConfig = store.getState().spider.preloadUrlConfig;
  return {
    validSize: preloadUrlConfig.file_max_size,
    validType: preloadUrlConfig.support_type,
    stopTime: preloadUrlConfig.file_preload_timeout * 1000, // ms
  };
};

/**
 * 为降低后端爬取ip被封率，由前端承担一部分爬取工作（不跨域的资源）
 * @param text - 用户输入的文字内容
 * @returns
 */
export const createSpider = async (text: string) => {
  enum ERROR_CODE {
    DOWN_LOAD_ERROR = 2001, // 文件下载错误
    CORS_ERROR = 2002, // 文件跨域
    OVERTIME_ERROR = 2003, // 文件请求超时
    FILE_TYPE_ERROR = 2004, // 文件不符合规定类型
    FILE_SIZE_ERROR = 2005, // 文件过大
    UPLOAD_ORTHER_ERROR = 2006, // 文件上传错误（这里指的是接口本身报错，例如404 502等）
  }
  // 检测后端有没有这个链接的缓存
  const checkSpiderCache = async (href: string) => {
    const { isCached } = await postCheckCache(href);
    return isCached;
  };

  /**
   * 该函数能够生成一个新的函数，能让传入请求在规定时间后中断
   * @param fetchFn 被装饰的请求函数
   * @param stopTime 在${stopTime}ms后中断请求
   * @returns
   */
  const fetchWithStop = <T extends (...args: any) => any>(fetchFn: T, stopTime: number) => {
    const controller = new AbortController();
    const signal = controller.signal;
    // 要爬取的资源地址
    return (...arg: any) => {
      let timer: number | null = window.setTimeout(() => {
        controller.abort();
        if (timer !== null) {
          clearTimeout(timer);
        }
        timer = null;
      }, stopTime);
      fetchFn(...arg, signal);
    };
  };

  // 开始爬取
  const startSpider = async function (this: any, signal?: AbortSignal) {
    let res;
    const beginTime = performance.now();
    const href = this.href;

    const trackFailSpider = (reson: (typeof ERROR_CODE)[keyof typeof ERROR_CODE]) => {
      const endTime = performance.now();
      trackCustomEvent({
        id: 'chat_context_load_result',
        is_success: 'fail',
        error_code: reson,
        url: href,
        duration: endTime - beginTime,
      });
      console.error(ERROR_CODE[reson]);
    };

    // 上传爬取的内容
    const upload = async ({
      body,
      type,
      href,
    }: {
      body: ReadableStream<Uint8Array>;
      type: string;
      href: string;
    }) => {
      const chunks = [];
      let result;
      const reader = body.getReader();
      while (!(result = await reader.read()).done) {
        chunks.push(result.value);
      }
      const blob = new Blob(chunks);
      const file = new File([blob], href, { type });
      const formData = new FormData();
      formData.append('file', file);
      formData.append('url', href);
      formData.append('type', type);

      try {
        const statusInfo = await postUploadSpider(formData);
        // 接口通了 但提示不成功
        if (statusInfo.code !== 0) {
          trackFailSpider(statusInfo.code);
        }
      } catch (error) {
        // 只有接口不通，被打回才会走这里
        trackFailSpider(ERROR_CODE.UPLOAD_ORTHER_ERROR);
      }
    };

    const { size, type } = await getHeader(href);
    if (!type) {
      // 失败说明跨域了，打个失败的埋点就好
      trackFailSpider(ERROR_CODE.CORS_ERROR);
      return;
    }
    // 非html文件，不允许没有size
    if (!type.includes('html') && !size) {
      trackFailSpider(ERROR_CODE.FILE_SIZE_ERROR);
      return;
    }
    // 非html文件，文件大小超过限制的直接返回
    if (!type.includes('html') && validSize < Number(size)) {
      trackFailSpider(ERROR_CODE.FILE_SIZE_ERROR);
      return;
    }
    // 文件类型不在支持列表内的直接返回，validType返回的是基本文件类型，实际上后面可能会跟一些辅助参数，所以要includes一下
    if (!validType.some((vt: string) => type.includes(vt))) {
      trackFailSpider(ERROR_CODE.FILE_TYPE_ERROR);
      return;
    }

    try {
      res = await fetch(href, {
        method: 'GET',
        credentials: 'omit',
        cache: 'no-cache',
        signal,
      });
    } catch (error) {
      console.error({ error });
      // 说明超时被中断了，打个失败的埋点
      trackFailSpider(ERROR_CODE.OVERTIME_ERROR);
      return;
    }
    if (!res.body) return;

    const endTime = performance.now();
    // 接口没报错，请求到了响应体，但这里并不能确定是否成功，如果获取不到header里的信息也应该算失败
    trackCustomEvent({
      id: 'chat_context_load_result',
      is_success: (type.includes('html') || size) && type ? 'success' : 'fail', // html文件可以不需要size
      url: href,
      duration: endTime - beginTime,
      file_size: Number(size) || undefined,
      file_type: type || undefined,
    });

    if (!type) return;

    upload({
      body: res.body,
      type,
      href,
    });
  };

  const getHeader = async (href: string) => {
    let res;
    let size;
    let type;

    try {
      res = await fetch(href, {
        method: 'HEAD',
        credentials: 'omit',
        cache: 'no-cache',
      });
    } catch (error) {
      console.error({ error });
      return { size, type };
    }

    if (res?.headers) {
      type = res.headers.get('Content-Type');
      size = res.headers.get('Content-Length');
    }

    return { size, type };
  };

  let couldStart = false;
  const matchList = await matchHref(text);
  const hrefList = Array.from(new Set(matchList)); // 匹配到的项要经过去重
  if (hrefList && hrefList.length) {
    // 获取到href时 上报一次埋点
    hrefList.forEach((href) => {
      trackCustomEvent({
        id: 'chat_context_load',
        url: href,
      });
    });

    try {
      // 查询缓存，没有缓存时允许前端爬取
      let i = 0;
      while (i < hrefList.length) {
        const href = hrefList[i];
        const isCached = await checkSpiderCache(href);
        if (!isCached) {
          couldStart = true;
          i++;
        } else {
          hrefList.splice(i, 1);
        }
      }
    } catch (error) {
      // 查询缓存接口报错时当作没有缓存即可
      couldStart = true;
      console.error(error);
    }
  } else {
    couldStart = false;
  }
  // 从后端拉取有效的爬取文件信息
  const { validSize, validType, stopTime } = await getValidSpiderInfo();

  return {
    couldStart,
    start: () => hrefList?.forEach((href) => fetchWithStop(startSpider.bind({ href }), stopTime)()), // 后端有策略，最多只等待前端15s，超过就默认失败了，因此前端也做个计时优化
  };
};
